import { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

interface ClickData {
    propertyId: number;
    agencyId: number;
    clickType: number;
}

export function useAddClickFromSite() {
    const [ isLoading, setIsLoading ] = useState(false);
    const [ error, setError ] = useState<string | null>(null);

    const addClick = async (data: ClickData) => {
        setIsLoading(true);
        setError(null);

        try {
            await axios.put(`${API_BASE_URL}/add-click-from-site`, data);
        } catch (error) {
            setError("Impossibile aggiungere il click");
        } finally {
            setIsLoading(false);
        }
    };

    return { addClick, isLoading, error };
}